import { AccountPanel } from "../../features/account/AccountPanel";

export function ConsoleAccountPage() {
  return (
    <div className="console-page">
      <div className="console-page-head">
        <h1 className="console-page-title">Settings</h1>
        <p className="console-page-sub">Your profile, access, and sign-in details.</p>
      </div>
      <AccountPanel />
    </div>
  );
}
